import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { logoutActionHandler } from "../../../store/actions/actionHandlers/loginActionHandler";
import LogoutIcon from "../SvgIcons/SidebarIcons/LogoutIcon";
import classes from "./Sidebar.module.scss";
import { sidebarTabs } from "../../../utils/sidebarTabs";
import getTenantName from "../../../utils/getTenantName";
import RoleMenuChek from "../../../hoc/RoleMenuCheck";

const Sidebar = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const commonState = useSelector((state) => state.commonReducer);
  const { isSidebarExapand, myProfile } = commonState;
  const { PaneColor, PrimaryColor1 } = JSON.parse(
    localStorage.getItem("themeData")
  ).CustomData;
  const tenantName = getTenantName(dispatch, location);
  const sideBarList = sidebarTabs(tenantName);

  const handleLogout = () => {
    dispatch(logoutActionHandler(navigate));
  };

  return (
    <aside
      className={classes.sideBar}
      style={{ flex: `0 1 ${isSidebarExapand ? "21.7rem" : "6.5rem"}` }}
    >
      <div className={classes.sideBar__list}>
        {sideBarList?.map((tab) => {
          return (
            <RoleMenuChek type={tab?.type} key={tab.key} feature={tab?.feature}>
              <div
                className={classes.sideBar__list__item}
                key={tab.key}
                onClick={() => navigate(tab.path)}
                style={{
                  backgroundColor: location.pathname.includes(tab.path)
                    ? PrimaryColor1
                    : "transparent",
                  color: location.pathname.includes(tab.path)
                    ? "#fff"
                    : "#404040",
                  fontWeight: location.pathname.includes(tab.path)
                    ? "bold"
                    : "normal",
                }}
              >
                <div
                  className={classes.sideBar__list__item__icon}
                  style={{
                    flex: `0 1 ${isSidebarExapand ? "35%" : "100%"}`,
                  }}
                >
                  {tab.icon(
                    location.pathname.includes(tab.path) ? "#fff" : "#000"
                  )}
                </div>
                <div
                  className={classes.sideBar__list__item__text}
                  style={{
                    flex: `0 1 ${isSidebarExapand ? "65%" : "0%"}`,
                  }}
                >
                  {tab.name}
                </div>
              </div>
            </RoleMenuChek>
          );
        })}
      </div>
      <div className={classes.sideBar__logout}>
        <div className={classes.sideBar__logout__icon} onClick={handleLogout}>
          <LogoutIcon />
        </div>
        <div
          className={classes.sideBar__logout__text}
          style={{
            width: isSidebarExapand ? "100%" : "0%",
            height: isSidebarExapand ? "100%" : "0%",
          }}
        >
          <p className={classes.sideBar__logout__text__one}>
            Logged In As
            <p className={classes.sideBar__logout__text__one__fullName}>{`${myProfile?.FirstName} ${myProfile?.LastName}`}</p>
          </p>
          <p className={classes.sideBar__logout__text__two}>
            Powered by Shotclasses <br />
            LTM 2016-{new Date().getFullYear()}
          </p>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
